module.exports = __webpack_public_path__ + "static/media/refresh-button.ffa7f36b.svg";